import React,{forwardRef} from "react";

const Button = forwardRef(({type="button",text, icon, bgColor, textColor, onClick,className },ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={`btn ${bgColor} ${textColor} ${className}`}
        onClick={onClick}
      >
        <i className={icon}></i> {text}
      </button>
    );
  }
);
  
  export default Button;
  